
import style from './App.module.css'
import { LogIn } from '../../Pages/Login/LogIn';
import { Route, Routes } from 'react-router-dom';
import { Home } from '../../Pages/Home/Home';
import { useDispatch } from 'react-redux';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import { useEffect } from 'react';
import { closeAllSelect } from '../../Redux/Slices/Select/Select';
import { Table } from '../../Pages/Table/Table';
import { WorkPlace } from '../../Pages/WorkPlace/WorkPlace';
import { getRegionThunk } from '../../Redux/Slices/User/thunks';

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getRegionThunk())
  }, [])

  function closest(e) {
    if(e.target.closest('.inputContainer')) return
    else if (e.target.classList.contains('overlay')){
      dispatch(closeAllSelect())
    }
    else if(!e.target.closest('.select')) {
      dispatch(closeAllSelect())
    }
  }


  useEffect(() => {
    window.addEventListener('click', closest)
    return () => {
      window.removeEventListener('click', closest)
    }
    // eslint-disable-next-line
  }, [dispatch])

  return (
    <div className={style.App}>
      <Routes>
        <Route path='/' element = {<Home />} >
          <Route path='/' element = {<ProtectedRoute><WorkPlace /></ProtectedRoute>} />
          <Route path='table' element = {<ProtectedRoute><Table /></ProtectedRoute>} />
          <Route path='settings' element = {<ProtectedRoute><div>Settings</div></ProtectedRoute>} />
          <Route path='report' element = {<ProtectedRoute><div>Report</div></ProtectedRoute>} />
        </Route>
        <Route path='/login' element = {<LogIn />}/>
      </Routes>
    </div>
  );
}

export default App;
